import tippy, { hideAll } from 'tippy.js';
import focusTrap from 'focus-trap';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import getStyle from '../../../javascripts/utils/get-style';

// Init media query
const mql = window.matchMedia('(min-width: 1024px)');

const stylesModifier = () => {
  let applyStyles = {};

  applyStyles = {
    name: 'applyStyles',
    enabled: false,
    phase: 'main',
  };

  return applyStyles;
};

// eslint-disable-next-line
const desktopSearchHide = (reference, controlTargetFocusTrap, $searchWrapper, $overlayBackground) => {
  reference.popper.style.height = null; // eslint-disable-line

  if (controlTargetFocusTrap) {
    controlTargetFocusTrap.deactivate();
  }

  setTimeout(() => {
    reference.popper.classList.remove(`${reference.popper.classList[0]}--active`);

    $overlayBackground.classList.remove('overlay-background--active');

    enableBodyScroll(document.body);

    setTimeout(() => {
      reference.hide();
      $searchWrapper.classList.remove('o-navigation__search--active');
      $overlayBackground.style.zIndex = null; // eslint-disable-line
    }, 500);
  }, 300);
};

const navigationSearch = () => {
  const $allSearchWrapper = document.body.querySelectorAll('.o-navigation__search');
  const $overlayBackground = document.body.querySelector('.overlay-background');

  $allSearchWrapper.forEach(($searchWrapper) => {
    const $searchButton = $searchWrapper.querySelector('.o-navigation__search-button');

    let controlTargetFocusTrap = null;

    tippy($searchButton, {
      content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        return template.innerHTML;
      },
      allowHTML: true,
      interactive: true,
      offset: [0, -40],
      // delay: [0, 1000],
      hideOnClick: false,
      popperOptions: {
        modifiers: [
          stylesModifier(),
        ],
      },
      onCreate(reference) {
        window.addEventListener('resize', () => {
          if (!mql.matches) {
            desktopSearchHide(reference, controlTargetFocusTrap, $searchWrapper, $overlayBackground); // eslint-disable-line
          }
        });
      },
      onTrigger(reference) {
        if (reference.popper.classList.contains('o-navigation__search-desktop--active')) {
          desktopSearchHide(reference, controlTargetFocusTrap, $searchWrapper, $overlayBackground);
        }
      },
      onShow(reference) {
        hideAll();
        disableBodyScroll(document.body);

        $searchWrapper.classList.add('o-navigation__search--active');
        $overlayBackground.style.zIndex = getStyle($searchWrapper, 'z-index') - 1;
        $overlayBackground.classList.add('overlay-background--active');
        reference.popper.classList.add('o-navigation__search-desktop');
      },
      onMount(reference) {
        reference.popper.classList.add('o-navigation__search-desktop--active');

        setTimeout(() => {
          const innerHeight = reference.popper.querySelector('.tippy-box').getBoundingClientRect().height;
          reference.popper.style.height = `${innerHeight}px`; // eslint-disable-line
        }, 500);

        controlTargetFocusTrap = focusTrap($searchWrapper, {
          onDeactivate: () => desktopSearchHide(reference, controlTargetFocusTrap, $searchWrapper, $overlayBackground), // eslint-disable-line
          initialFocus: reference.popper.querySelector('input[type="search"]'),
          clickOutsideDeactivates: true,
        });

        controlTargetFocusTrap.activate();
      },
      onHide() {
        // $searchWrapper.classList.remove('o-navigation__search--active');
      },
      onClickOutside(reference) {
        desktopSearchHide(reference, controlTargetFocusTrap, $searchWrapper, $overlayBackground);
      },
    });
  });
};

export default navigationSearch;
